export const featureFlagKeys = {
  enableMaintenanceBanner: 'enable-maintenance-banner',
} as const

export type FeatureFlagKey = (typeof featureFlagKeys)[keyof typeof featureFlagKeys]
